import moment from "moment";
import { DateFilterTypes } from "../constants";

export const applyPresetDateFilter = (date: string, filterValue: any) => {
  if (!date) {
    return false;
  }
  switch (filterValue.type) {
    case DateFilterTypes.TODAY:
      return moment(date).isSame(new Date(), "day");
    case DateFilterTypes.YESTERDAY:
      return moment(date).isSame(moment().subtract(1, "day"), "day");
    case DateFilterTypes.LAST_WEEK:
      return (
        moment(date).isSameOrAfter(moment().subtract(14, "days")) &&
        moment(date).isSameOrBefore(moment().subtract(7, "days"))
      );
    case DateFilterTypes.LAST_MONTH:
      return (
        moment(date).isSameOrAfter(moment().subtract(2, "month")) &&
        moment(date).isSameOrBefore(moment().subtract(1, "month"))
      );
    default:
      return false;
  }
};

export const applyCustomDateFilter = (date: string, filterValue: any) => {
  if (!filterValue.startDate || !filterValue.endDate) return false;
  return moment(date).isSameOrAfter(filterValue.startDate) && moment(date).isSameOrBefore(filterValue.endDate);
};
